import Link from "next/link";
import { styled } from "@mui/material";
import { Poppins } from "next/font/google";
import { Box } from "@mui/material";
import { useRouter } from "next/router";

import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SearchIcon from "@mui/icons-material/Search";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { isPermittedModuleOperation } from "../../hooks/HelperFunctions";
import React, { useEffect, useState } from "react";

import Drawer from "@mui/material/Drawer";
import PermanentDrawer from "../PermanentDrawer/PermanentDrawer";
import CloseIcon from "@mui/icons-material/Close";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const StickyFooterContainer = styled(Box)(({ theme }) => ({
  padding: "17px 4px !important",
  width: "100% !important",
  fontFamily: poppins.style.fontFamily,
  display: "block",
  background: "#ffffff !important",
  boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.08) !important",
  zIndex: 1000,
  position: "fixed !important",
  bottom: 0,
  left: 0,
  right: 0,
  [theme.breakpoints.up("lg")]: {
    display: "none",
  },
}));

const FooterContainer = styled(Box)(() => ({
  fontFamily: poppins.style.fontFamily,
  display: "flex",
  gap: "4px",
  alignItems: "center",
  justifyContent: "center",
  "& a": {
    minWidth: "75px",
    color: "#5C677D",
    fontSize: "12px",
    fontWeight: 500,
    textDecoration: "none",
    display: "flex",
    gap: "4px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  "& a svg": {
    padding: "6px 0px !important",
    width: "100%",
    borderRadius: "99px",
    color: "#001233",
  },
  "& a.activeRoute": {
    color: "#004FE0",
    "& svg": {
      color: "#004FE0",
      background: "#EBF2FF",
    },
  },
}));

const StickyFooter = () => {
  const router = useRouter();
  const envType = process.env.NEXT_PUBLIC_PROJECT_ENV;
  const isActive = (path) => router.pathname === path;

  const [activeUserType, setActiveUserType] = useState(null);
  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    if (!orgId || !(orgId > 0)) {
      setActiveUserType("student");
    }
    if (orgId && orgId > 0) {
      setActiveUserType("teacher");
    }
  }, []);

  const [mobileMneuStatus, setMobileMneuStatus] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const handleOpenDrawer = () => {
    setMobileMneuStatus("MobileMenuShow");
    setOpenDrawer(true);
  };
  const toggleDrawerClsoe = () => {
    setMobileMneuStatus(null);
    setOpenDrawer(false);
  };

  const FooterArr = [
    {
      link: activeUserType === "teacher" ? "/teaching-home" : "/inbox-student",
      label: activeUserType === "teacher" ? "Dashboard" : "Inbox",
      icon:
        activeUserType === "teacher" ? <HomeRoundedIcon /> : <ChatBubbleIcon />,
    },
    {
      link: activeUserType === "teacher" ? "/inbox-teacher" : "/my-learning",
      label: activeUserType === "teacher" ? "Inbox" : "Learning",
      icon:
        activeUserType === "teacher" ? <ChatBubbleIcon /> : <MenuBookIcon />,
    },
    {
      link: activeUserType === "teacher" ? "/my-courses" : "/search",
      label: activeUserType === "teacher" ? "Courses" : "Explore",
      icon: activeUserType === "teacher" ? <MenuBookIcon /> : <SearchIcon />,
    },
    {
      link: "",
      label: "More",
      icon: <MenuRoundedIcon />,
      onClick: handleOpenDrawer,
    },
  ]?.filter(Boolean);

  return (
    <>
      <StickyFooterContainer>
        <FooterContainer>
          {FooterArr.map(({ link, label, icon, onClick }, index) => (
            <Link
              href={link}
              className={isActive(link) ? "activeRoute" : ""}
              key={index}
              onClick={onClick}
            >
              {icon}
              <span>{label}</span>
            </Link>
          ))}
        </FooterContainer>
      </StickyFooterContainer>

      <div>
        <Drawer open={openDrawer} onClose={toggleDrawerClsoe}>
          <button
            style={{
              position: "absolute",
              zIndex: "9999",
              right: "24px",
              top: "24px",
              border: "none",
              background: "none",
            }}
            onClick={toggleDrawerClsoe}
          >
            <CloseIcon style={{ fontSize: "30px" }} />
          </button>

          <PermanentDrawer
            menuStatus={mobileMneuStatus}
            MenuClosed={toggleDrawerClsoe}
          />
        </Drawer>
      </div>
    </>
  );
};

export default StickyFooter;
